// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3ETaP","title":"FrontImage_title__2G50Z"};